
import checkVersion from "@/utils/check-version";
export default {
  name: 'App',
  mounted() {
    checkVersion();
  }
}
